import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';

const OurFeatures = ({ featuresData }: { featuresData: any }) => {
    return (
        <FeaturesWrapper>
            {featuresData.map((featureData: any) => {
                return (
                    <FeatureWrapper>
                        <Image
                            src={featureData.imageUrl.data.attributes.url}
                            width={100}
                            height={100}
                        />
                        <FeatureText>{featureData.text}</FeatureText>
                    </FeatureWrapper>
                );
            })}
        </FeaturesWrapper>
    );
};

export default OurFeatures;

const FeaturesWrapper = styled.div`
    display: flex;
    width: calc(100% - 24px);
    padding: 12px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    background: #000;
`;

const FeatureWrapper = styled.div`
    width: calc((100% - 24px) / 3);
`;

const FeatureText = styled.div`
    color: #fff;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
`;
